import { type ZoneSheet as ZoneSheetData, zoneSheetText } from "../../shared/zones";
import { Button } from "./Button";
import { Sheet } from "./Sheet";

const BADGE: Record<ZoneSheetData["kind"], { src: string; size: number }> = {
  slow: { src: "/icons/zone-slow-44.svg", size: 50 },
  noParking: { src: "/icons/zone-noparking-44.svg", size: 50 },
  noRide: { src: "/icons/zone-noriding-44.svg", size: 50 },
  outside: { src: "/icons/zone-boundary-44.svg", size: 44 },
};

/**
 * Figma K2–K5 (342:14959…): a tap on a zone opens its sheet, the 02b pattern: 44 px badge, title,
 * subtitle, rules, "OK" closes it (as do X and a tap on the map).
 */
export function ZoneSheet(props: { zone: ZoneSheetData; onClose: () => void }) {
  const text = () => zoneSheetText(props.zone);
  const badge = () => BADGE[props.zone.kind];
  return (
    <Sheet onClose={props.onClose}>
      <div class="flex items-start gap-3 pr-8">
        {/* The 44 px badges sit on a 50 px canvas (shadow): drawn at (−3, −2). */}
        <span class="relative h-11 w-11 shrink-0">
          <img
            src={badge().src}
            width={badge().size}
            height={badge().size}
            alt=""
            class={badge().size === 50 ? "absolute -left-[3px] -top-[2px] max-w-none" : ""}
          />
        </span>
        <div class="min-w-0 leading-[1.25]">
          <h2 class="text-xl font-semibold tracking-[0.2px] text-strong">{text().title}</h2>
          <p class="mt-[6px] text-[13px] tracking-[0.13px] text-text">{text().subtitle}</p>
        </div>
      </div>
      <p class="mt-[22px] text-sm leading-[1.25] tracking-[0.14px] text-text">{text().body}</p>
      <Button class="mt-6 -mx-[5px] !w-[calc(100%+10px)]" onClick={props.onClose}>
        OK
      </Button>
      <div class="h-10 short:h-0" />
    </Sheet>
  );
}
